import { Text } from "@aidron/aidron-ds";

import { i18n } from "../../../translate/i18n";

import {
  OuterContainer,
  InnerContainer,
  SubtitleContainer
} from "./ClientFlowSection.style";

import { 
  CustomText,
  CustomHeading
} from "../../StyledComponents/styleComponents.index";

import { IconButtonWithModal } from "../sharedComponents.index";

import PropTypes from "prop-types";
import { createPercentFormatter } from "../../../utils/formatter/formatter";

export function ClientFlowSection({ ctx, uiState }) {
  const { t } = i18n;

  const { clientFlow } = ctx || {};
  const { numberSize = "lg" } = uiState || {};

  return clientFlow ? (
    <OuterContainer>
      <InnerContainer>
        <SubtitleContainer>
          <CustomText weight="bold" size="15px" fontSize={['0.2rem', '0.5rem', '1rem']}>
            {t("flowDependencyForSelling")}
          </CustomText>
          
          <IconButtonWithModal
            icon="help-circle"
            modalHeading={`${t("help")}: ${t("flowDependencyForSelling")}`}
            renderModalContent={() => <Text>{t("flowDependencyForSellingExplanation")}</Text>}
          />
        </SubtitleContainer>

        <CustomHeading size={numberSize ?? "lg"} color="orange">
          {createPercentFormatter({ minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(clientFlow / 100)}
        </CustomHeading>
      </InnerContainer>
    </OuterContainer>
  ) : (
    <></>
  );
}

ClientFlowSection.propTypes = {
  ctx: PropTypes.shape(),
  uiState: PropTypes.shape()
}